import { Component, OnInit, ChangeDetectorRef } from '@angular/core';

// RxJS
import {
    AppState,
    UPDATE_CONTENT,
    ADD_APP_ID,
    ADD_APPLICATION_ID,
    UPDATE_PERSONA
} from '../app-reducer';
import { Store } from '@ngrx/store';
import {Observable, Subscription } from 'rxjs';
import { Router } from '@angular/router';
// pop up
import { MatDialog } from '@angular/material/dialog';
import { PendingBlocksAlertComponent } from './pending-blocks-alert.component';

// animations
import { animate, style, transition, trigger } from '@angular/animations';

// services
import { QuestionService } from '../services/question.service';
import { ApiService } from 'src/app/services/api.service';
import { ComposableService } from '../services/composable.service';
import { NavigationService } from '../services/navigation.service';


// utilities
import { find, get, isEmpty } from 'lodash';
import {B} from '@angular/cdk/keycodes';
import { first, skipWhile } from 'rxjs/operators';
import { CommonService } from '../services/common.service';
import {Buffer} from 'buffer';

@Component({
    selector: 'demo-resume-app.component',
    templateUrl: './demo-resume-app.component.html',
    styleUrls: [],
    animations: [
        trigger(
            'inOutAnimation',
            [
                transition(
                    ':enter',
                    [
                        style({ height: 0, opacity: 0 }),
                        animate('1s ease-out',
                            style({ height: 300, opacity: 1 }))
                    ]
                ),
                transition(
                    ':leave',
                    [
                        style({ height: 300, opacity: 1 }),
                        animate('1s ease-in',
                            style({ height: 0, opacity: 0 }))
                    ]
                )
            ]
        )
    ]
})
export class DemoResumeApplicationComponent implements OnInit {

  constructor(
    private apiService: ApiService,
    private store: Store<AppState>,
    private disclosure: MatDialog,
    private composableService: ComposableService,
    public service: QuestionService,
    private changeDetection: ChangeDetectorRef,
    private navigationService: NavigationService,
    private router: Router,
    private commonService: CommonService
  ) {
    
    this.appState$ = this.store.select('sections');
    this.store.dispatch({
      type: UPDATE_PERSONA,
      payload: {
        name: 'InsuredOwner',
        id: 2.1
      }
    });
  }

  public pageGuard: boolean;
  appState$: Observable<any>;
  unauthenticated = false;
  timeOutFlag = false;
  loadingDemoApp= true;
  error = false;
  agentName: string;
  AgentId: string;
  AgentFirstName: string;
  AgentLastName: string;
  AgentEmailAddress: string;

  ngOnInit() {
    // reset app state
    this.composableService.resetApplication();
    this.appState$.pipe(first()).subscribe((state: any) => {
      this.commonService.logAppState(state);
    });
      // Get producer credentials from ISAM headers or use hard-coded values for local and dev
    this.AgentId = (window['jhConfig'].ivuser !== '') ? window['jhConfig'].ivuser : 'DreamFinFit';
    this.AgentFirstName = (window['jhConfig'].firstname !== '') ? unescape(window['jhConfig'].firstname) : 'Dream';
    this.AgentLastName = (window['jhConfig'].lastname !== '') ? unescape(window['jhConfig'].lastname) : 'FinFit';
    this.agentName = (this.AgentFirstName && this.AgentLastName) ? this.AgentFirstName + ' ' + this.AgentLastName : 'Kim Possible';
    this.AgentEmailAddress = (window['jhConfig'].email !== '') ? window['jhConfig'].email : 'test@test.com';

    this.resumeDemoAppProposedInsured();
  }
  ngAfterViewInit(){
    
  }
   resumeDemoAppProposedInsured(){
      const urlData = new URL(location.href);
      const appId= urlData.searchParams.get('AppId')
      const payload = {
        'AppId': appId,
      };
      this.resumeApplication(payload);
    }


  resumeApplication(resumePayload) {
    try{
      this.apiService.demoResumeApplication(resumePayload).subscribe(response => {
        if (response.code === 200 && response.data) {
          let resumeAppObj = {
            ...response.data
          };
          
          // if there are any pending jobs/blocks in the queue wait until it finishes
          if (response.data.PendingJobs) {
            const modalRef = this.disclosure.open(PendingBlocksAlertComponent, {
              disableClose: true,
              hasBackdrop: true,
              data: {
                resumePayload,
                PendingJobs: response.data.PendingJobs
              }
            });
            this.changeDetection.detectChanges();

            modalRef.afterClosed().subscribe(checkResult => {
              resumeAppObj = {...checkResult.data};
              this.continueWithDemoApplication(checkResult, resumeAppObj);
            });
            return false;
          }
          
          this.continueWithDemoApplication(response, resumeAppObj);
          this.checkIfDemoApplication(response);

        } else {
          console.log('Failure to resume application');
        }
      }, (error) => {
        console.log('ERROR');
        console.log(error);
        });
      } catch (e) {
      console.log('ERROR - Resume Application exception caught');
      console.log(e);
      this.unauthenticated = true;
    }
  }

  checkIfDemoApplication(response: any) {
    const appId = get(response, 'data.ApplicationId');
    const payload = {
      'appId': appId
    };
    this.apiService.isDemoApplication(payload).subscribe((resp) => {
      if (resp){
        this.appState$.pipe(first()).subscribe((state: any) => {
          state.isDemo = true;
          this.commonService.logAppState(state);
        });
      }
    });
  }

  continueWithDemoApplication(response: any, resumeAppObj: any) {
    const rawPayload = resumeAppObj.EAppRawPayload;
    const payload = rawPayload ? window['JSON'].parse((Buffer.from(rawPayload,'base64')).toString()) : this.service.generateEAppRawPayload(resumeAppObj.QuestionBlocks,resumeAppObj.QuestionBlockResponses);
    // if empty redirect to error page
    if (!rawPayload && isEmpty(payload)) {      
      this.goToBlankApplicationLoadedErrorPage();
    } else {
      //  update store
      this.store.dispatch({
        type: ADD_APP_ID,
        payload: get(response, 'data.AppAuthId')
      });
      this.store.dispatch({
        type: ADD_APPLICATION_ID,
        payload: get(response, 'data.ApplicationId')
      });
      this.store.dispatch({
        type: UPDATE_CONTENT,
        payload: payload
      });
      // enter eApp
      this.goToEapp();
        
      }    
   }

  // blank application error page
  goToBlankApplicationLoadedErrorPage() {
    this.loadingDemoApp = false;
    // determine which section
    console.log('Blank application detected. Redirecting to the appropriate error page.');
    this.navigationService.nextSectionRelative('error-blank-application');

  }

  goToEapp(): void {
    this.appState$.pipe(
      // tslint:disable-next-line:indent
      skipWhile((state: any) => {
        return (state.formData === null) || (state.questions === null);
      }),
      first()
    ).subscribe((state) => {
      if (state.questions) {
        const routes = this.router.config;
        const newRoutes = routes.map(item => {
        const { data } = item;
        if (data && data.blockHeading && data.blockName && data.blockName !== 'intake' && data.hasOwnProperty('isProgressRoute')) {
          const questionBlocks = find(state.questions, { Name: data.blockName });
          item.data.blockCategory = questionBlocks.BlockCategory || null;
          item.data.blockHeading = questionBlocks.DisplayName || null;
        }
        return item;
        });
        this.navigationService.buildNavStore(newRoutes);
      };
      this.loadingDemoApp = false;

      // determine which section
      console.log('Going to eApp');
      this.navigationService.nextSectionRelative('proposed-insured');
      
      // trigger observable holding block submissions until application pre-processing is done
      this.navigationService.readyToSubmit(true);
    });
    
  }   
}
